import { render, staticRenderFns } from "./CardDetailsProfiler.vue?vue&type=template&id=b8dac0fe&scoped=true"
import script from "./CardDetailsProfiler.vue?vue&type=script&lang=js"
export * from "./CardDetailsProfiler.vue?vue&type=script&lang=js"
import style0 from "./CardDetailsProfiler.vue?vue&type=style&index=0&id=b8dac0fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8dac0fe",
  null
  
)

export default component.exports